export default __webpack_public_path__ + "static/media/classroom-animals.853e0643.png";